export default {"src":"/_next/static/media/pulse_icon_rgb_black.b002e6ed.svg","height":203,"width":203,"blurWidth":0,"blurHeight":0};